var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 893.40125,
    height: 636.63257,
    viewBox: "0 0 893.40125 636.63257",
    xmlSpace: "preserve",
    style: {
      clipRule: "evencodd",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    id: "svg3357",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3361"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Draft-1",
    transform: "matrix(0.829192,0,0,1.09268,-411.66916,-1894.9016)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.84208,-22.8293)",
    id: "g3254"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-190.401,-2760.71)",
    id: "g3212"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1017.47,5157.99 42.85,131.9 h 138.69 l -112.2,81.52 42.86,131.9 -112.2,-81.52 -112.206,81.52 42.857,-131.9 -112.202,-81.52 h 138.69 z",
    id: "path3208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1017.47,5157.99 42.85,131.9 h 138.69 l -112.2,81.52 42.86,131.9 -112.2,-81.52 -112.206,81.52 42.857,-131.9 -112.202,-81.52 h 138.69 z m 0,90.11 16.37,50.39 c 3.73,11.48 14.42,19.24 26.48,19.24 h 52.99 c 0,0 -42.87,31.15 -42.87,31.15 -9.76,7.09 -13.84,19.66 -10.11,31.13 l 16.37,50.4 c 0,0 -42.87,-31.15 -42.87,-31.15 -9.76,-7.09 -22.97,-7.09 -32.73,0 l -42.869,31.15 c 0,0 16.374,-50.4 16.374,-50.4 3.728,-11.47 -0.356,-24.04 -10.116,-31.13 l -42.868,-31.15 c 0,0 52.988,0 52.988,0 12.064,0 22.755,-7.76 26.481,-19.24 z",
    id: "path3210"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.884659,0.186218,-0.245392,0.671332,1784.74,-1575.76)",
    id: "g3218"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1017.47,5157.99 42.85,131.9 h 138.69 l -112.2,81.52 42.86,131.9 -112.2,-81.52 -112.206,81.52 42.857,-131.9 -112.202,-81.52 h 138.69 z",
    id: "path3214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1017.47,5157.99 42.85,131.9 h 138.69 l -112.2,81.52 42.86,131.9 -112.2,-81.52 -112.206,81.52 42.857,-131.9 -112.202,-81.52 h 138.69 z m 0,118.37 8.06,24.83 c 4.9,15.07 18.95,25.28 34.79,25.28 h 26.11 c 0,0 -21.12,15.35 -21.12,15.35 -12.82,9.31 -18.19,25.82 -13.29,40.89 l 8.07,24.83 c 0,0 -21.12,-15.34 -21.12,-15.34 -12.82,-9.32 -30.18,-9.32 -43.005,0 l -21.122,15.34 c 0,0 8.068,-24.83 8.068,-24.83 4.897,-15.07 -0.468,-31.58 -13.289,-40.89 L 948.5,5326.47 c 0,0 26.109,0 26.109,0 15.847,0 29.891,-10.21 34.791,-25.28 z",
    id: "path3216"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.884659,0.186218,0.245392,0.671332,259.12,-1575.76)",
    id: "g3224"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1017.47,5157.99 42.85,131.9 h 138.69 l -112.2,81.52 42.86,131.9 -112.2,-81.52 -112.206,81.52 42.857,-131.9 -112.202,-81.52 h 138.69 z",
    id: "path3220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1017.47,5157.99 42.85,131.9 h 138.69 l -112.2,81.52 42.86,131.9 -112.2,-81.52 -112.206,81.52 42.857,-131.9 -112.202,-81.52 h 138.69 z m 0,118.37 -8.07,24.83 c -4.9,15.07 -18.944,25.28 -34.791,25.28 H 948.5 c 0,0 21.122,15.35 21.122,15.35 12.821,9.31 18.186,25.82 13.289,40.89 l -8.068,24.83 c 0,0 21.122,-15.34 21.122,-15.34 12.825,-9.32 30.185,-9.32 43.005,0 l 21.12,15.34 c 0,0 -8.07,-24.83 -8.07,-24.83 -4.9,-15.07 0.47,-31.58 13.29,-40.89 l 21.12,-15.35 c 0,0 -26.11,0 -26.11,0 -15.84,0 -29.89,-10.21 -34.79,-25.28 z",
    id: "path3222"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11471,0.349275,-0.460263,0.845908,497.25,-191.148)",
    id: "g3238"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.87,-3239.62)",
    id: "g3228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1080.96,5296.59 c 0,0 36.17,-231.99 174.21,-242.89 29.24,33.1 39.42,76.66 39.42,76.66 0,0 -107.47,-9.07 -213.63,166.23 z",
    id: "path3226"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996889,-0.0788221,0.108848,1.37664,-242.167,-5159.72)",
    id: "g3232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1104.47,5305.5 c 0,0 -14.43,-160.47 146.78,-271.97 29.24,33.11 26.78,30.32 26.78,30.32 0,0 -113.53,61.27 -173.56,241.65 z",
    id: "path3230"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.97875,-0.205058,-0.198059,0.945342,3545.47,-2724.49)",
    id: "g3236"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1104.47,5305.5 c 0,0 -14.43,-160.47 146.78,-271.97 29.24,33.11 26.78,30.32 26.78,30.32 0,0 -113.53,61.27 -173.56,241.65 z",
    id: "path3234"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.10402,0.368307,0.485342,0.837797,1476.65,-197.854)",
    id: "g3252"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9.0862419,-19156.67,1192.2551)",
    id: "g3242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1080.96,5296.59 c 0,0 36.17,-231.99 174.21,-242.89 29.24,33.1 39.42,76.66 39.42,76.66 0,0 -107.47,-9.07 -213.63,166.23 z",
    id: "path3240"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996889,-0.0788221,0.108848,1.37664,-242.167,-5159.72)",
    id: "g3246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1104.47,5305.5 c 0,0 -14.43,-160.47 146.78,-271.97 29.24,33.11 26.78,30.32 26.78,30.32 0,0 -113.53,61.27 -173.56,241.65 z",
    id: "path3244"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.93162,-0.363435,-0.365538,0.937011,4369.86,-2496.41)",
    id: "g3250"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1104.47,5305.5 c 0,0 -14.43,-160.47 146.78,-271.97 29.24,33.11 26.78,30.32 26.78,30.32 0,0 -113.53,61.27 -173.56,241.65 z",
    id: "path3248"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 596.116,825.861 c 0,0 -52.222,-44.715 -111.298,-40.798 -18.93,12.729 -21.215,67.888 -21.215,67.888 0,0 50.916,-8.812 62.992,0.326 12.077,9.139 -66.909,-85.839 69.521,-27.416 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3256"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 716.647,1006.84 65.291,44.84 c 0,0 29.105,25.96 64.766,5.77",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.54px"
    },
    id: "path3260"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3266"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 803.439,1068.69 c 0,0 26.221,11.59 45.068,-6.96 18.846,-18.56 -88.087,137.25 -88.087,137.25 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3264"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3270"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 916.108,1101.06 -42.609,-40.87 -1.639,56.85 97.509,77.84 -53.261,-93.82",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3268"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3274"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 867.223,874.396 c 0,0 9.115,126.254 9.115,131.994 0,5.74 -24.644,40.18 -43.211,31.73 -18.568,-8.44 -113.429,-41.181 -130.309,-41.181 -16.879,0 121.869,0 121.869,0 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3272"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 911.55,994.081 c 0,0 3.457,36.489 -21.03,47.729 -24.486,11.23 129.63,-50.806 146.34,-47.729 16.71,3.076 -125.31,0 -125.31,0 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path3280"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3286"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 859.587,1091.81 -1.921,24.16 -86.369,74.74 c 0,0 80.958,-69.82 88.29,-98.9 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3284"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3290"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 995.732,1023.27 c 0,0 -76.63,41.87 -84.012,41.87 -7.383,0 29.022,34.76 29.531,42.66 0.509,7.89 -10.183,-36.41 -10.183,-36.41 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3288"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3294"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 528.83,1091.81 18.272,-32.93 30.713,11.67 -48.985,-72.315 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3292"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3298"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 522.221,1096.21 31.101,22.16 -117.02,3.88 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3296"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3302"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 587.534,1076.77 -16.717,36.93 103.802,-59.87 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3300"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3306"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 524.936,1160.05 36.2,-30.65 1.63,17.61 -12.066,12.39 -33.917,93.93 z",
    style: {
      fill: "#ffffff",
      stroke: "#ffffff",
      strokeWidth: "2.54px"
    },
    id: "path3304"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.85997,-2.06205,1214.94)",
    id: "g3310"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 570.817,1129.4 13.8,44.68 83.161,33.26 -49.244,-77.94 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3308"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3314"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1182.99,996.858 -34.21,109.392 -78.98,-31.77 23.94,35.57 -4.9,11.63 -58.36,-71.13 96.79,29.88 54.85,-86.349",
    style: {
      fill: "#ffffff"
    },
    id: "path3312"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3318"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1096.45,1131.75 40.13,3.83 -40.13,35.75 -58.6,41.33 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3316"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3322"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1136.58,1176.92 9,-38.18 22.12,27.48 23.59,83.89 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3320"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1191.29,1095.21 c 0,0 -30.4,26.47 -42.55,26.47 -12.16,0 128.88,0 128.88,0 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3324"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1153.84,1140.93 16.29,19.94 21.16,-6.32 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3328"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3334"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1182.99,1015.43 v 71.12",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.54px"
    },
    id: "path3332"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3338"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 581.611,724.172 c 0,0 -70.294,-52.94 -95.427,-58.288 0.802,16.31 -9.464,36.568 -9.464,36.568 21.319,0.884 43.94,18.773 62.404,33.217 0,0 -78.393,-63.368 42.487,-11.497 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3336"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3342"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 698.263,670.894 28.913,2.628 c 0,0 -14.676,97.637 -1.972,132.954 12.704,35.317 -51.911,-106.345 -26.941,-135.582 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3340"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3346"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 932.316,670.894 c 0,0 26.61,-8.435 31.339,-5.01 5.856,4.241 13.858,139.736 -1.095,175.729 -2.67,-58.529 -11.006,-145.502 -30.244,-170.719 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3344"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3350"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1158.75,816.05 c 0,0 52.78,4.611 50.06,25.563 -2.72,20.953 -88.65,29.332 -125.08,60.322 48.19,-16.746 100.33,-32.251 156.67,-11.105 1.93,-5.641 1.51,-65.734 -5.39,-78.739 -17.9,-5.025 -55.69,-11.243 -76.26,3.959 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3348"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g3354"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1175.72,675.507 c 0,0 38.93,-18.82 30.81,12.77 -23.92,16.823 -75.61,58.776 -80.07,67.495 42.16,-36.077 99.33,-63.847 99.33,-63.847 l -8.72,-41.958 c 0,0 -32.64,14.594 -41.35,25.54 z",
    style: {
      fill: "#ffffff"
    },
    id: "path3352"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.edb07372920bd5a8c0c260888ee0fe44.svg";
export { ForwardRef as ReactComponent };